import script from "./FoilCutterTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FoilCutterTable.vue?vue&type=script&setup=true&lang=js"

import "./FoilCutterTable.vue?vue&type=style&index=0&id=2f357286&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f357286"]])

export default __exports__